function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  id: "style2",
  type: "text/css"
}, "\n\n        .st0, .st2 {\n            stroke: #FFFFFF;\n            fill: #fff;\n        }\n\n        .st1 {\n            fill: none;\n            stroke: #FFFFFF;\n            stroke-dasharray: 12.124, 12.124;\n        }\n    ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.2,-0.55647247)",
  id: "g12"
}, /*#__PURE__*/React.createElement("path", {
  id: "path4",
  d: "M 0.2,11.2 C 2,12 3.8,12.8 5.7,13.7",
  className: "st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "path6",
  d: "M 16.5,19.2 C 60,42.1 116.3,83 177.2,115 c 16.1,8.4 41.4,13.6 70,7.3 4.8,-1.1 51.9,-12.2 68,-52.2 2.8,-6.9 11.6,-28.7 0.7,-45.6 -9.2,-14.5 -25.2,-22 -37.4,-23.6 -10.5,-1.4 -31,1.2 -44.5,13 -8.5,7.4 -11.2,17.2 -11.9,19.8 -0.7,2.6 -3.2,12.9 0.7,23.8 5,14.1 19.4,30.8 27.5,35.2 51.3,27.7 63.6,22.4 83.2,26.9 42.1,9.5 14.6,1.5 103.3,24.8 10.3,2.7 27.1,5.3 41.3,5 20.3,-0.5 49.2,-13.4 67,-19.2 14.8,-4.8 46,-9 60.1,9.2 6.9,8.9 8.4,21.6 5.4,34.7",
  className: "st1"
}), /*#__PURE__*/React.createElement("path", {
  id: "path8",
  d: "m 609,179.9 c -0.6,1.9 -1.3,3.7 -2.1,5.6",
  className: "st0"
}), /*#__PURE__*/React.createElement("path", {
  id: "path10",
  d: "m 607.6,183.9 4.2,-0.4 v 0.1 l -4.6,4.3 c -1.3,1.7 -2.6,3.3 -3.9,5 0.5,-2 1,-4.1 1.4,-6.1 l 0.4,-6.3 0.1,-0.1 z",
  className: "st2"
}));

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 192.34352,
    width: 611.86823,
    className: "svg-line",
    viewBox: "0 0 611.86823 192.34353",
    y: "0px",
    x: "0px",
    id: "Layer_1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.2f0a4e11.svg";
export { ForwardRef as ReactComponent };